import React from "react";

import type { Point } from "~/tools/point";

import { PositionedPopover, type TimeLinePopoverPlacement } from "../../_popover";

import { usePopoverLine } from "./usePopoverLine";

interface TimelineLinePopoverProps {
	/**
	 * Unique identifier for the Popover component.
	 * This ensures that only one Popover is rendered at a time, preventing overlapping or multiple Popovers from being displayed.
	 */
	popoverId: string;

	/**
	 * @default 0
	 */
	offset?: number | Point;

	/**
	 * @default "bottom-right"
	 */
	placement?: TimeLinePopoverPlacement;

	/**
	 * The width of the Popover in pixels.
	 * @default 340
	 */
	width?: number;
}

export const TimelinePopover: React.FC<React.PropsWithChildren<TimelineLinePopoverProps>> = ({
	popoverId,
	children,
	...props
}) => {
	const [popoverLine, hoverLine] = usePopoverLine();

	if (popoverId !== popoverLine?.popoverId) {
		return null;
	}

	return (
		<PositionedPopover {...props} onHover={(isHovered) => hoverLine(isHovered)} position={popoverLine.position}>
			{children}
		</PositionedPopover>
	);
};
